// Description: Component to welcome the user with 
// Updated: 12/08/2025
// Author: Simon Franklin

// React
import React, { useEffect } from 'react';

// Material UI Components 
import { Box, Button } from '@mui/material'

// Components and functions for the project
import Titles from '../../components/Titles/Titles'
import Badge from '../../assets/badges/image.png';
import { ReactComponent as TagIcon } from '../../assets/Icons/svg/TagIcon.svg';
import { ReactComponent as CampaignIcon } from '../../assets/Icons/svg/CampaignIcon.svg';
import { useNavigate } from 'react-router-dom';
import WhatsAppIcon from './whatsappIcon.png';
import LinearProgress from '@mui/material/LinearProgress';
import ThemeColors from '../../components/ThemeColors/ThemeColors';
import { useLocation } from 'react-router-dom';
import AvatarIA from '../../assets/images/robo.png';
import AlternativeAvatar from '../../assets/images/avatar-padrao.png';
import { isAuthenticated } from '../../authMiddleware';
import use123zapStore from '../../context/123zapStore';
import { translatePlan } from '../../utils/utils';

const SVGIcons = {
    Settings: ({ color = '#303035' }) => (
        <svg width="23" height="22" viewBox="0 0 23 22" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0503 16.8484L16.7003 18.1984C16.5503 18.3484 16.4753 18.5234 16.4753 18.7234C16.4753 18.9234 16.5503 19.0984 16.7003 19.2484C16.8503 19.3984 17.0295 19.4776 17.2378 19.4859C17.4461 19.4943 17.6253 19.4234 17.7753 19.2734L19.8253 17.2234C20.142 16.9068 20.3003 16.5318 20.3003 16.0984C20.3003 15.6651 20.142 15.2901 19.8253 14.9734L17.7503 12.8984C17.6003 12.7484 17.4253 12.6776 17.2253 12.6859C17.0253 12.6943 16.8503 12.7734 16.7003 12.9234C16.5503 13.0734 16.4753 13.2484 16.4753 13.4484C16.4753 13.6484 16.5503 13.8234 16.7003 13.9734L18.0753 15.3234H14.3503C14.1336 15.3234 13.9545 15.3943 13.8128 15.5359C13.6711 15.6776 13.6003 15.8568 13.6003 16.0734C13.6003 16.2901 13.6753 16.4734 13.8253 16.6234C13.9753 16.7734 14.1586 16.8484 14.3753 16.8484H18.0503ZM17.2503 21.8484C15.6503 21.8484 14.2878 21.2859 13.1628 20.1609C12.0378 19.0359 11.4753 17.6734 11.4753 16.0734C11.4753 14.4734 12.0378 13.1151 13.1628 11.9984C14.2878 10.8818 15.6503 10.3234 17.2503 10.3234C18.8503 10.3234 20.2086 10.8818 21.3253 11.9984C22.442 13.1151 23.0003 14.4734 23.0003 16.0734C23.0003 17.6734 22.442 19.0359 21.3253 20.1609C20.2086 21.2859 18.8503 21.8484 17.2503 21.8484ZM9.35028 21.8484C8.81695 21.8484 8.35862 21.6776 7.97528 21.3359C7.59195 20.9943 7.36695 20.5651 7.30028 20.0484L7.07528 18.3734C6.99195 18.3401 6.90862 18.2984 6.82528 18.2484L6.57528 18.0984L5.05028 18.7484C4.56695 18.9484 4.07528 18.9693 3.57528 18.8109C3.07528 18.6526 2.69195 18.3401 2.42528 17.8734L0.775284 14.9484C0.508617 14.4984 0.429451 14.0193 0.537784 13.5109C0.646117 13.0026 0.908617 12.5901 1.32528 12.2734L2.62528 11.2734V10.7234L1.32528 9.74844C0.891951 9.43177 0.625284 9.01927 0.525284 8.51094C0.425284 8.0026 0.508617 7.5151 0.775284 7.04844L2.42528 4.14844C2.69195 3.69844 3.07112 3.3901 3.56278 3.22344C4.05445 3.05677 4.54195 3.07344 5.02528 3.27344L6.62528 3.92344C6.70862 3.87344 6.78362 3.8276 6.85028 3.78594C6.91695 3.74427 6.99195 3.70677 7.07528 3.67344L7.30028 1.97344C7.36695 1.4401 7.59195 1.0026 7.97528 0.660937C8.35862 0.319271 8.81695 0.148438 9.35028 0.148438H12.6503C13.1836 0.148438 13.642 0.319271 14.0253 0.660937C14.4086 1.0026 14.6336 1.4401 14.7003 1.97344L14.9253 3.67344C15.0086 3.70677 15.092 3.74427 15.1753 3.78594C15.2586 3.8276 15.342 3.87344 15.4253 3.92344L16.9503 3.27344C17.4336 3.07344 17.9253 3.05677 18.4253 3.22344C18.9253 3.3901 19.3086 3.69844 19.5753 4.14844L21.5253 7.54844C21.6586 7.78177 21.7211 8.03594 21.7128 8.31094C21.7045 8.58594 21.617 8.8401 21.4503 9.07344C21.367 9.17344 21.2628 9.23177 21.1378 9.24844C21.0128 9.2651 20.892 9.2401 20.7753 9.17344C20.242 8.8901 19.6795 8.6776 19.0878 8.53594C18.4961 8.39427 17.892 8.32344 17.2753 8.32344C16.6919 8.32344 16.1128 8.3901 15.5378 8.52344C14.9628 8.65677 14.4086 8.84844 13.8753 9.09844C13.542 8.59844 13.117 8.20677 12.6003 7.92344C12.0836 7.6401 11.5336 7.49844 10.9503 7.49844C9.98362 7.49844 9.16278 7.83594 8.48778 8.51094C7.81278 9.18594 7.47528 10.0068 7.47528 10.9734C7.47528 11.6901 7.67528 12.3443 8.07528 12.9359C8.47528 13.5276 9.00862 13.9568 9.67528 14.2234C9.59195 14.5068 9.53778 14.7943 9.51278 15.0859C9.48778 15.3776 9.47528 15.6734 9.47528 15.9734C9.47528 16.6734 9.56695 17.3609 9.75028 18.0359C9.93362 18.7109 10.2003 19.3484 10.5503 19.9484C10.7836 20.3818 10.8003 20.8068 10.6003 21.2234C10.4003 21.6401 10.0836 21.8484 9.65028 21.8484H9.35028Z"
                fill={color} />
        </svg>
    )
}

const Welcome = () => {

    const navigate = useNavigate();
    const userInfo = use123zapStore((state) => state.userInfo);
    const setUserInfo = use123zapStore((state) => state.setUserInfo);
    const planoAtual = use123zapStore((state) => state.planoAtual);
    const userAvatar = use123zapStore((state) => state.userAvatar);
    const userAuthenticated = use123zapStore((state) => state.userAuthenticated);
    const setUserAvatar = use123zapStore((state) => state.setUserAvatar);

    useEffect(() => {
        if (userInfo['UUID'] && userAvatar === null) {
            const userHash = userInfo['UUID'] + '.png';
            fetchUserAvatar(userHash);
        }
    }, [userInfo, userAvatar]);

    useEffect(() => {
        if (userAuthenticated && Object.keys(userInfo).length === 0) {
            const { decryptedData } = isAuthenticated();
            setUserInfo(decryptedData);
        }
    }, [userAuthenticated, userInfo]);


    const fetchUserAvatar = async (userHash) => {
        try {
            const imageUrl = 'https://files-public-139308022743-prod.s3.us-east-1.amazonaws.com/avatar_users/' + userHash;
            const img = new Image();
            img.onload = () => {
                setUserAvatar(imageUrl);
            };
            img.onerror = () => {
                console.error('Erro ao carregar a imagem:', imageUrl);
                setUserAvatar(AlternativeAvatar);
            };
            img.src = imageUrl;
        } catch (error) {
            console.error('Erro ao buscar o avatar do usuário:', error);
            setUserAvatar(AlternativeAvatar);
        }
    };

    const location = useLocation();
    const path = location.pathname;

    function openWhatsApp() {
        window.open('https://wa.me/551151042151?text=Ol%C3%A1%2C%20estou%20precisando%20de%20suporte!%20', '_blank');
    }

    const hexToRgb = (hex) => {
        hex = hex.replace(/^#/, '');
        if (hex.length === 3) {
            hex = hex.split('').map(x => x + x).join('');
        }
        const num = parseInt(hex, 16);
        return `${(num >> 16) & 255}, ${(num >> 8) & 255}, ${num & 255}`;
    };

    return (
        <Box flex={1} display={'flex'} flexDirection={'column'} sx={{ height: { xl: '312px', xs: '290px' } }}>
            <Box
                sx={{
                    background: '#F5F3FF',
                    flex: 1,
                    display: 'flex',
                    padding: { xs: '18px', sm: '22px', xl: '30px' },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    border: '1px solid #D9D9DC',
                    borderRadius: '12px',
                    borderBottomLeftRadius: '0px',
                    borderBottomRightRadius: '0px'
                }}
            >
                <Box display={'flex'} justifyContent={'space-between'} minWidth={'100%'}>
                    <Box display={'flex'} gap={'15px'}>
                        <Box
                            component="img"
                            src={userAvatar}
                            sx={{
                                borderRadius: '12px',
                                width: { xs: '46px', sm: '55px', xl: '71px' },
                                height: { xs: '46px', sm: '55px', xl: '71px' },
                                opacity: 0,
                                transition: 'opacity 0.5s ease-in-out',
                                '&:not([src=""])': {
                                    opacity: 1,
                                }
                            }}
                            alt="Logo"
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', maxHeight: { xs: '46px', sm: '55px', xl: '71px' } }}>
                            <Titles children={`Olá, ${userInfo['NAME']}!`} styles={{ fontSize: { xl: '16px', xs: '11px', sm: '14px' } }} color={'#303035'} font='medium' />
                            <Titles children={path === '/painel' ? 'O que iremos fazer hoje?' : 'O que iremos analisar hoje?'} styles={{ fontSize: { xl: '30px', xs: '20px', sm: '24px' } }} color={'#303035'} font='medium' />
                        </Box>
                    </Box>
                    <Box display={'none'} gap={'15px'} sx={{ cursor: 'pointer' }} onClick={() => { navigate('/configurações') }}>
                        <SVGIcons.Settings color={'#300D68'} />
                    </Box>
                </Box>
                <Box display={'flex'} justifyContent={'space-between'} gap={'15px'}>
                    <Box
                        sx={{
                            background: '#8033F4',
                            color: '#EDE8FF',
                            borderRadius: '6px',
                            height: { xs: '39px', sm: '44px', xl: '49px' },
                            display: 'flex',
                            alignItems: 'center',
                            gap: '7px',
                            flex: '1',
                            padding: { xs: '0 0 0 7px', xl: '0 0 0 10px', sm: '0 0 0 8px' },
                            cursor: 'pointer',
                            transition: '.3s',
                            '&:hover': {
                                background: '#7121E0',
                                scale: '1.05'
                            },
                            marginTop: { xs: '5px', sm: '10px', lg: '0px' }
                        }}
                        onClick={() => { path === '/painel' ? navigate('/campanhas/adicionar') : navigate('/campanhas') }}
                    >
                        <CampaignIcon width={'18px'} height={'18px'} fill={'#EDE8FF'} />
                        <Titles color={'#EDE8FF'} styles={{ fontSize: { xl: '16px', lg: '12px', md: '16px', sm: '16px', xs: '10px' } }} children={path === '/painel' ? `Criar uma nova campanha` : `Gerenciar campanhas`} />
                    </Box>
                    <Box
                        sx={{
                            background: '#8033F4',
                            color: '#EDE8FF',
                            borderRadius: '6px',
                            height: { xs: '39px', sm: '44px', xl: '49px' },
                            display: 'flex',
                            alignItems: 'center',
                            gap: '7px',
                            flex: '1',
                            padding: { xs: '0 0 0 7px', xl: '0 0 0 10px', sm: '0 0 0 8px' },
                            cursor: 'pointer',
                            transition: '.3s',
                            '&:hover': {
                                background: '#7121E0',
                                scale: '1.05'
                            },
                            marginTop: { xs: '5px', sm: '10px', lg: '0px' }
                        }}
                        onClick={() => { path === '/painel' ? navigate('/canais/adicionar') : navigate('/canais') }}
                    >
                        <TagIcon width={'18px'} height={'18px'} fill={'#EDE8FF'} />
                        <Titles color={'#EDE8FF'} children={path === '/painel' ? `Adicionar um novo canal` : `Visualizar meus canais`}
                            styles={{ fontSize: { xl: '16px', lg: '12px', md: '16px', sm: '16px', xs: '10px' } }} />
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    background: '#1F0944',
                    height: { xs: '70px', sm: '100px' },
                    padding: { xs: '0 18px', sm: '0 30px' },
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: '1px solid #1F0944',
                    borderRadius: '12px',
                    borderTopLeftRadius: '0px',
                    borderTopRightRadius: '0px'
                }}
            >
                <Box display={'flex'} gap={'10px'}>
                    <Box
                        component={'img'}
                        sx={{
                            width: { xs: path === '/painel' ? '50px' : '80px', xl: path === '/painel' ? '60px' : '90px' },
                            height: { xs: path === '/painel' ? '50px' : '80px', xl: path === '/painel' ? '60px' : '90px' },
                        }}
                        alt={path === '/painel' ? 'Seu plano atual' : 'Inteligência Artificial'}
                        src={path === '/painel' ? Badge : AvatarIA}
                    />
                    <Box display="flex" flexDirection="column" justifyContent="center">
                        <Titles color="#F5F3FF" children={path === '/painel' ? 'Plano atual' : 'Inteligência'} styles={{ fontSize: { xl: '16px', xs: '13px' } }} />
                        <Box minHeight="32px" display="flex" alignItems="center">
                            {planoAtual !== null ? (
                                <Titles
                                    color="#F5F3FF"
                                    children={path === '/painel' ? translatePlan(planoAtual) : 'Zapi!'}
                                    styles={{ fontSize: { xl: '20px', xs: '16px' } }}
                                />
                            ) : (
                                <LinearProgress
                                    sx={{
                                        height: '10px',
                                        borderRadius: '6px',
                                        minWidth: '50px',
                                        width: '100%',
                                        backgroundColor: ThemeColors.purple800,
                                        '& .MuiLinearProgress-bar': {
                                            backgroundColor: ThemeColors.purple900,
                                        },
                                    }}
                                />
                            )}
                        </Box>
                    </Box>

                </Box>
                <Button
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        background: '#F5F3FF',
                        borderRadius: '6px',
                        padding: { xs: '6px 12px', sm: '10px 18px', xl: '12px 24px' },
                        color: '#1F0844',
                        fontSize: { xs: '11px', sm: '14px', xl: '16px' },
                        transition: '.3s',
                        '&:hover': {
                            scale: '1.05',
                            background: '#EDEBF7',
                        }
                    }}
                    onClick={openWhatsApp}

                >
                    <Box component={'img'} src={WhatsAppIcon} sx={{ width: { xs: '18px', xl: '20px' }, height: { xs: '23px', xl: '25px' }, objectFit: 'contain' }} />
                    Falar com o Suporte
                </Button>
            </Box>
        </Box>
    )
}

export default Welcome